module.exports = __webpack_public_path__ + "static/media/landing-page_card_min.d07b1cee.jpg";